import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "../services/api";

const ProtectedRoute = ({ children }) => {

  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {

    checkAuth();

  }, []);

  const checkAuth = async () => {

    try {

      const res = await api.get("/profile");

      if (res.data.success) {
        setIsAuthenticated(true);
      }

    } catch (error) {

      setIsAuthenticated(false);

    } finally {

      setLoading(false);

    }
  };

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "20px",
          fontWeight: "600"
        }}
      >
        Checking Authentication...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;